import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid } from '@mui/material'
import ElectricityIcon from '@mui/icons-material/FlashOn'
import schema from '../../schemas/eldemand.json'
import { JSONSchema7 } from 'json-schema'
import { ElDemand } from '../../interfaces/eldemand'
import CreateElDemand from './CreateElDemand'
import EditElDemand from './EditElDemand'
import DeleteElDemand from './DeleteElDemand'

export interface Props {
	disabled: boolean
	data: ElDemand[]
	setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function ElDemandList({ disabled, data, setData }: Props) {
	return (
		<List
			dense
			subheader={
				<ListSubheader>
					<Grid container alignItems={'center'}>
						{'Electricity Demand'}
						<CreateElDemand
							disabled={disabled || (data && data.length > 0)}
							data={data}
							schema={schema as JSONSchema7}
							setData={setData}
						/>
					</Grid>
				</ListSubheader>
			}
		>
			{data.map((obj: ElDemand, index: number) => {
				return (
					<ListItem
						key={index}
						secondaryAction={
							<>
								<EditElDemand disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
								<DeleteElDemand disabled={disabled} value={obj} setData={setData} />
							</>
						}
						disablePadding
					>
						<ListItemButton disabled={disabled}>
							<ListItemIcon>
								<ElectricityIcon />
							</ListItemIcon>
							<ListItemText
								primary={obj.name}
								secondary={``}
								sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
							/>
						</ListItemButton>
					</ListItem>
				)
			})}
		</List>
	)
}
